import React, { useState, useEffect, useRef, Fragment } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  Box,
  Card,
  Button,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Table,
  makeStyles,
  Container,
  Divider,
  CardContent,
  CardHeader,
  Grid,
  TextField,
  MenuItem,
  InputLabel
} from '@material-ui/core';
import Page from 'src/components/Page';
import services from '../Services';
import { useNavigate } from 'react-router-dom';
import authService from '../../../../utils/permissionAuth';
import tokenService from '../../../../utils/tokenDecoder';
import { trackPromise } from 'react-promise-tracker';
import { Formik } from 'formik';
import * as Yup from 'yup';
import {
  DatePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import moment from 'moment';
import xlsx from 'json-as-xlsx';
import Autocomplete from '@material-ui/lab/Autocomplete';
import ReactToPrint from 'react-to-print';
import CreatePDF from './CreatePDF';
import { endOfMonth } from 'date-fns';
import { LoadingComponent } from '../../../../utils/newLoader';
import { useAlert } from 'react-alert';
import CreateBankWiseCustomerPDF from './CreateBankWiseCustomerPDF';
import TablePagination from '@material-ui/core/TablePagination';

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  avatar: {
    marginRight: theme.spacing(2)
  },
  row: {
    marginTop: '1rem'
  },
  colorCancel: {
    backgroundColor: 'red'
  },
  colorRecordAndNew: {
    backgroundColor: '#FFBE00'
  },
  colorRecord: {
    backgroundColor: 'green'
  }
}));

const screenCode = 'PAYPASTREPORTRTF';

export default function PayPastReportRTF(props) {
  const [title, setTitle] = useState('Pay Past Report - RTF');
  const alert = useAlert();
  const classes = useStyles();
  const [groups, setGroups] = useState();
  const [factories, setFactories] = useState();
  const [routes, setRoutes] = useState();
  const [branches, setBranches] = useState();
  const [bankList, setBankList] = useState([]);
  const [selectedDate, setSelectedDate] = useState();
  const [branchIsclear, setBranchIsclear] = useState(false);
  const [bankIsclear, setBankIsclear] = useState(false);
  const [selectedDatePDF, setSelectedDatePDF] = useState();
  const [bankCustomerData, setBankCustomerData] = useState([]);
  const [bankCustomerList, setBankCustomerList] = useState({
    groupID: '0',
    factoryID: '0',
    routeID: '0',
    bankID: '0',
    branchID: '0',
    year: '',
    month: ''
  });
  const [selectedSearchValues, setSelectedSearchValues] = useState({
    groupName: '0',
    factoryName: '0',
    monthName: '',
    year: '',
    monthName: '',
    routeName: '',
    bankName: '',
    branchName: ''
  });
  let bankName = bankList[bankCustomerList.bankID - 1] === undefined ? '' : bankList[bankCustomerList.bankID - 1];

  let branchName = branches && bankCustomerList && bankCustomerList.branchID !== undefined
    ? branches[bankCustomerList.branchID - 1]
    : 'Unknown Branch';

  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isFactoryFilterEnabled: false
  });

  const [maxDate, setMaxDate] = useState(new Date());
  const [month, setMonth] = useState(['JANUARY', 'FEBRUARY', 'MARCH', 'APRIL', 'MAY', 'JUNE', 'JULY', 'AUGUST', 'SEPTEMBER', 'OCTOBER', 'NOVEMBER', 'DECEMBER'])
  const navigate = useNavigate();
  const csvHeaders = [];
  const componentRef = useRef();
  const componentRef1 = useRef();
  const [totalAmount, setTotalAmount] = useState();
  const [totalAmountpdf, setTotalAmountpdf] = useState();
  const [alertCount, setAlertCount] = useState({
    count: 0
  });
  const [limit, setLimit] = useState(5);
  const [page, setPage] = useState(0);

  useEffect(() => {
    setBankCustomerList((prev) => ({
      ...prev,
      bankID: '0',
      branchID: '0'
    }))
  }, [bankCustomerList.routeID])

  useEffect(() => {
    setBankCustomerList((prev) => ({
      ...prev,
      bankID: '0',
      branchID: '0'
    }))
  }, [bankCustomerList.year, bankCustomerList.month])

  useEffect(() => {
    setBankCustomerList((prev) => ({
      ...prev,
      branchID: '0'
    }))
  }, [bankCustomerList.bankID])

  useEffect(() => {
    trackPromise(getGroupsForDropdown(), getPermission());
  }, []);

  useEffect(() => {
    if (bankCustomerList.factoryID > 0 && bankCustomerList.groupID > 0) {
      trackPromise(GetBalancePaymentYearMonthForDropDown());
    }
  }, [bankCustomerList.factoryID, bankCustomerList.groupID]);

  useEffect(() => {
    trackPromise(getFactoriesForDropDown());
  }, [bankCustomerList.groupID]);

  useEffect(() => {
    trackPromise(getRoutesByFactoryID());
  }, [bankCustomerList.factoryID]);

  useEffect(() => {
    trackPromise(getBanksForDropdown());
  }, []);

  useEffect(() => {
    getBranchesForDropdown();
    setBankCustomerData([])
  }, [bankCustomerList.bankID]);

  useEffect(() => {
    setBankCustomerData([])
  }, [bankCustomerList.branchID]);

  useEffect(() => {
    trackPromise(checkISBalancePaymentCompleted());
  }, [bankCustomerList.groupID, bankCustomerList.factoryID]);

  useEffect(() => {
    setAlertCount({
      count: alertCount.count + 1
    });
  }, [bankCustomerList.year]);

  useEffect(() => {
    setBankCustomerList((prev) => ({
      ...prev,
      routeID: '0',
    }))
  }, [bankCustomerList.groupID, bankCustomerList.factoryID]);

  async function getPermission() {
    var permissions = await authService.getPermissionsByScreen(screenCode);
    var isAuthorized = permissions.find(
      p => p.permissionCode == 'VIEWPAYPASTREPORTRTF'
    );

    if (isAuthorized === undefined) {
      navigate('/404');
    }
    var isGroupFilterEnabled = permissions.find(
      p => p.permissionCode == 'GROUPDROPDOWN'
    );
    var isFactoryFilterEnabled = permissions.find(
      p => p.permissionCode == 'FACTORYDROPDOWN'
    );

    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
      isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined
    });

    setBankCustomerList({
      ...bankCustomerList,
      groupID: parseInt(tokenService.getGroupIDFromToken()),
      factoryID: parseInt(tokenService.getFactoryIDFromToken())
    });
  }

  async function getGroupsForDropdown() {
    const groups = await services.getAllGroups();
    setGroups(groups);
  }

  async function getFactoriesForDropDown() {
    const factory = await services.getFactoryByGroupID(
      bankCustomerList.groupID
    );
    setFactories(factory);
  }

  async function getRoutesByFactoryID() {
    const route = await services.getRoutesForDropDown(
      bankCustomerList.factoryID
    );
    setBankIsclear(!bankIsclear)
    setRoutes(route);
  }

  async function getBanksForDropdown() {
    const bank = await services.getBanksForDropdown();
    setBankList(bank);
  }

  async function getBranchesForDropdown() {
    const branch = await services.getBranchesByBankID(
      parseInt(bankCustomerList.bankID)
    );
    setBranches(branch);
  }

  async function GetBalancePaymentYearMonthForDropDown() {
    var response = await services.GetBalancePaymentYearMonth(bankCustomerList.groupID, bankCustomerList.factoryID);
    const applicableYear = parseInt(response.applicableYear);
    const applicableMonth = parseInt(response.applicableMonth) - 1;

    const selectedDate = new Date(applicableYear, applicableMonth);
    setSelectedDate(selectedDate);
    setSelectedDatePDF(selectedDate);
  };

  function generateDropDownMenu(data) {
    let items = [];
    if (data != null) {
      for (const [key, value] of Object.entries(data)) {
        items.push(
          <MenuItem key={key} value={key}>
            {value}
          </MenuItem>
        );
      }
    }
    return items;
  }

  function handleDateChange(date) {
    let monthNames = [
      'JANUARY',
      'FEBRUARY',
      'MARCH',
      'APRIL',
      'MAY',
      'JUNE',
      'JULY',
      'AUGUST',
      'SEPTEMBER',
      'OCTOBER',
      'NOVEMBER',
      'DECEMBER'
    ];
    var month = date.getUTCMonth() + 1;
    var year = date.getUTCFullYear();
    let monthName = monthNames[month - 1];
    setSelectedSearchValues({
      ...selectedSearchValues,
      monthName: monthName
    });
    setBankCustomerList({
      ...bankCustomerList,
      month: month.toString(),
      year: year.toString()
    });
    setBankIsclear(!bankIsclear)
    setBranchIsclear(!branchIsclear)

    if (selectedDate != null) {
      var prevMonth = selectedDate.getUTCMonth() + 1;
      var prevyear = selectedDate.getUTCFullYear();

      if ((prevyear == year && prevMonth != month) || prevyear != year) {
        setSelectedDate(date);
        setSelectedDatePDF(date);
      }
    } else {
      setSelectedDate(date);
      setSelectedDatePDF(date);
    }
    setBankCustomerData([]);
  }

  async function GetDetails() {
    if (
      bankCustomerList.groupID > 0 &&
      bankCustomerList.factoryID > 0 &&
      selectedDate != null &&
      selectedDate !== ''
    ) {

      const applicableYear = selectedDate.getFullYear().toString();
      const applicableMonth = (selectedDate.getMonth() + 1).toString();

      let model = {
        groupID: parseInt(bankCustomerList.groupID),
        factoryID: parseInt(bankCustomerList.factoryID),
        routeID: parseInt(bankCustomerList.routeID),
        bankID: parseInt(bankCustomerList.bankID),
        branchID: parseInt(bankCustomerList.branchID),
        applicableMonth: applicableMonth,
        applicableYear: applicableYear
      };

      getSelectedDropdownValuesForReport(model);

      let total = 0;

      const customerData = await services.GetBankCustomerDetails(model);
      if (customerData.statusCode === 'Success' && customerData.data !== null) {
        setBankCustomerData(customerData.data);
        createDataForExcel(customerData.data);
        customerData.data.forEach((x) => {
          total = total + parseFloat(x.amount);
        });

        setTotalAmount(total);
        setTotalAmountpdf(total.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));

        if (customerData.data.length === 0 && alertCount.count > 1) {
          alert.error('NO RECORDS TO DISPLAY');
        }
      }
    }
  }

  async function createDataForExcel(array) {
    var res = [];
    if (array != null) {
      array.map(x => {
        var vr = {
          "RegNo": x.registrationNumber,
          "Name": x.name,
          "Route": x.routeName,
          "Bank Code and Bank Name": x.bankName,
          "Branch Name and Branch Code": x.branchName,
          "Account Number": x.accountNumber,
          "Transaction Code": '052 - Supplier',
          "Amount (LKR)": x.amount
        };
        res.push(vr);
      });
    }
    return res;
  }

  async function createFile() {
    var file = await createDataForExcel(bankCustomerData);
    var settings = {
      sheetName: 'Pay Past Report - RTF',
      fileName:
        'Pay Past Report - RTF ' +
        selectedSearchValues.factoryName +
        ' PAY PAST REPORT FOR THE MONTH OF ' +
        month[selectedDatePDF.getMonth()] +
        '-' +
        selectedDatePDF.getFullYear().toString() +
        ' (' +
        (bankName.bankName === undefined ? 'All Banks' : bankName.bankName) +
        ')',
      writeOptions: {}
    };

    let keys = Object.keys(file[0]);
    let tempcsvHeaders = csvHeaders;
    keys.map((sitem, i) => {
      tempcsvHeaders.push({ label: sitem, value: sitem });
    });
    file.push({});

    let filterData = {
      "RegNo": "Group: " + groups[bankCustomerList.groupID],
      "Name": "Factory: " + factories[bankCustomerList.factoryID],
    }
    file.push(filterData);

    let routeData = {
      "RegNo": "Route: " + (routes[bankCustomerList.routeID] === undefined ? "All Routes" : routes[bankCustomerList.routeID]),
    }
    file.push(routeData);

    let filterDate = {
      "RegNo": "Month: " + month[(selectedDate.getMonth())],
      "Name": "Year: " + selectedDate.getFullYear().toString()
    }
    file.push(filterDate);

    let filterDetail = {
      "RegNo": "Bank: " + (bankName.bankName === undefined ? "All Banks" : bankName.bankName),
      "Name": "Branch: " + (branchName === undefined ? "All Branches" : branchName.branchName),
    }
    file.push(filterDetail);

    let dataA = [
      {
        sheet: 'Pay Past Report - RTF',
        columns: tempcsvHeaders,
        content: file
      }
    ];

    xlsx(dataA, settings);
  }

  async function checkISBalancePaymentCompleted() {
    const response = await services.CheckISBalancePaymentCompleted(
      bankCustomerList.groupID,
      bankCustomerList.factoryID
    );
    const bDate = moment(
      response.data.lastBalancePaymentSchedule,
      moment.defaultFormat
    ).toDate();
    var result = endOfMonth(bDate);

    setMaxDate(result);
  }

  function cardTitle(titleName) {
    return (
      <Grid container spacing={1}>
        <Grid item md={10} xs={12}>
          {titleName}
        </Grid>
      </Grid>
    );
  }

  function handleChange(e) {
    const target = e.target;
    const value = target.value;
    setBankCustomerList({
      ...bankCustomerList,
      [e.target.name]: value
    });
    setBankCustomerData([]);
    setBankIsclear(!bankIsclear)
    setBranchIsclear(!branchIsclear)
  }

  function handleSearchDropdownChange(data, e) {
    if (data === undefined || data === null) {
      setBankCustomerList({
        ...bankCustomerList,
        bankID: '0'
      });
      return;
    } else {
      var nameV = 'bankID';
      var valueV = data['bankID'];
      setBankCustomerList({
        ...bankCustomerList,
        bankID: valueV.toString()
      });

      setBranchIsclear(!branchIsclear)
    }
  }

  function handleSearchDropdownBranch(data, e) {
    if (data === undefined || data === null) {
      setBankCustomerList({
        ...bankCustomerList,
        branchID: '0'
      });
      return;
    } else {
      var valueV = data['branchID'];
      setBankCustomerList({
        ...bankCustomerList,
        branchID: valueV.toString()
      });
    }
  }

  function getSelectedDropdownValuesForReport(searchForm) {
    setSelectedSearchValues({
      ...selectedSearchValues,
      groupName: groups[searchForm.groupID],
      factoryName: factories[searchForm.factoryID],
      routeName: routes[searchForm.routeID],
      month: searchForm.month,
      year: searchForm.year,
      bankName: bankList[searchForm.bankID],
      branchName: branches[searchForm.branchID]
    });
  }

  const handleLimitChange = (event) => {
    setLimit(event.target.value);
  };
  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const getPageMargins = () => {
    return `@media print {
            @page {
            background-color: white !important;
        }
        body {
            transform-origin: top left;
            background-color: white !important;
        }
    }`;
  };

  return (
    <Fragment>
      <LoadingComponent />
      <Page className={classes.root} title={title}>
        <Container maxWidth={false}>
          <Formik
            initialValues={{
              groupID: bankCustomerList.groupID,
              factoryID: bankCustomerList.factoryID,
              bankID: bankCustomerList.bankID,
              selectedDate: selectedDate
            }}
            validationSchema={Yup.object().shape({
              groupID: Yup.number()
                .required('Group required')
                .min('1', 'Group required'),
              factoryID: Yup.number()
                .required('Factory required')
                .min('1', 'Factory required'),
              selectedDate: Yup.string()
                .required('Select applicable month')
                .nullable()
            })}
            enableReinitialize
          >
            {({ errors, handleBlur, handleSubmit, touched }) => (
              <form onSubmit={handleSubmit}>
                <Box mt={0}>
                  <Card>
                    <CardHeader title={cardTitle(title)} />
                    <PerfectScrollbar>
                      <Divider />
                      <CardContent>
                        <Grid container spacing={3}>
                          <Grid item md={3} xs={8}>
                            <InputLabel shrink id="groupID">
                              Group *
                            </InputLabel>
                            <TextField
                              select
                              error={Boolean(touched.groupID && errors.groupID)}
                              fullWidth
                              helperText={touched.groupID && errors.groupID}
                              name="groupID"
                              onBlur={handleBlur}
                              onChange={e => handleChange(e)}
                              value={bankCustomerList.groupID}
                              variant="outlined"
                              id="groupID"
                              disabled={!permissionList.isGroupFilterEnabled}
                              size="small"
                            >
                              <MenuItem value="0">--Select Group--</MenuItem>
                              {generateDropDownMenu(groups)}
                            </TextField>
                          </Grid>

                          <Grid item md={3} xs={8}>
                            <InputLabel shrink id="factoryID">
                              Factory *
                            </InputLabel>
                            <TextField
                              select
                              error={Boolean(
                                touched.factoryID && errors.factoryID
                              )}
                              fullWidth
                              helperText={touched.factoryID && errors.factoryID}
                              name="factoryID"
                              onBlur={handleBlur}
                              onChange={e => handleChange(e)}
                              value={bankCustomerList.factoryID}
                              variant="outlined"
                              id="factoryID"
                              disabled={!permissionList.isFactoryFilterEnabled}
                              size="small"
                            >
                              <MenuItem value="0">--Select Factory--</MenuItem>
                              {generateDropDownMenu(factories)}
                            </TextField>
                          </Grid>

                          <Grid item md={3} xs={8}>
                            <InputLabel shrink id="routeID">
                              Route
                            </InputLabel>
                            <TextField
                              select
                              fullWidth
                              name="routeID"
                              onBlur={handleBlur}
                              onChange={e => handleChange(e)}
                              value={bankCustomerList.routeID}
                              variant="outlined"
                              id="routeID"
                              size="small"
                            >
                              <MenuItem value="0">--Select Routes--</MenuItem>
                              {generateDropDownMenu(routes)}
                            </TextField>
                          </Grid>

                          <Grid item md={3} xs={8}>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                              <DatePicker
                                error={Boolean(
                                  touched.selectedDate && errors.selectedDate
                                )}
                                helperText={
                                  touched.selectedDate && errors.selectedDate
                                }
                                autoOk
                                fullWidth
                                id="selectedDate"
                                variant="inline"
                                openTo="month"
                                views={['year', 'month']}
                                label="Year and Month *"
                                value={selectedDate}
                                maxDate={maxDate}
                                disableFuture={true}
                                onChange={date => handleDateChange(date)}
                                size="small"
                              />
                            </MuiPickersUtilsProvider>
                          </Grid>

                          <Grid item md={3} xs={8}>
                            <InputLabel shrink id="bankID">
                              Bank
                            </InputLabel>
                            <Autocomplete
                              id="bankID"
                              options={bankList}
                              key={bankIsclear}
                              getOptionLabel={option =>
                                option.bankName.toString()
                              }
                              onChange={(e, value) =>
                                handleSearchDropdownChange(value, e)
                              }
                              defaultValue={null}
                              renderInput={params => (
                                <TextField
                                  {...params}
                                  variant="outlined"
                                  name="bankID"
                                  fullWidth
                                  value={bankCustomerList.bankID}
                                  getOptionDisabled={true}
                                  size="small"
                                />
                              )}
                            />
                          </Grid>

                          <Grid item md={3} xs={8}>
                            <InputLabel shrink id="branchID">
                              Branch
                            </InputLabel>
                            <Autocomplete
                              id="branchID"
                              options={branches}
                              key={branchIsclear}
                              getOptionLabel={option =>
                                option.branchName.toString()
                              }
                              onChange={(e, value) =>
                                handleSearchDropdownBranch(value, e)
                              }
                              defaultValue={null}
                              renderInput={params => (
                                <TextField
                                  {...params}
                                  variant="outlined"
                                  name="branchID"
                                  fullWidth
                                  value={bankCustomerList.branchID}
                                  getOptionDisabled={true}
                                  size="small"
                                />
                              )}
                            />
                          </Grid>
                          <Grid container justify="flex-end">
                            <Box pr={2}>
                              <Button
                                color="primary"
                                variant="contained"
                                type="submit"
                                onClick={() => trackPromise(GetDetails())}
                              >
                                Search
                              </Button>
                            </Box>
                          </Grid>
                        </Grid>
                        <br />
                        <br />
                        <br />
                        <br />

                        <Box minWidth={1050}>
                          {bankCustomerData.length > 0 ? (
                            <TableContainer>
                              <Table aria-label="caption table" size="small">
                                <TableHead>
                                  <TableRow>
                                    <TableCell align={'left'} style={{ border: "1px solid #ccc" }}>Reg No</TableCell>
                                    <TableCell align={'left'} style={{ border: "1px solid #ccc" }}>Name</TableCell>
                                    <TableCell align={'left'} style={{ border: "1px solid #ccc" }}>Route</TableCell>
                                    <TableCell align={'left'} style={{ border: "1px solid #ccc" }}>Bank Code & Bank Name</TableCell>
                                    <TableCell align={'left'} style={{ border: "1px solid #ccc" }}>Branch Name & Branch Code</TableCell>
                                    <TableCell align={'left'} style={{ border: "1px solid #ccc" }}>Account Number</TableCell>
                                    <TableCell align={'left'} style={{ border: "1px solid #ccc" }}>Transaction Code</TableCell>
                                    <TableCell align={'right'} style={{ border: "1px solid #ccc" }}>Amount (LKR)</TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {bankCustomerData.slice(page * limit, page * limit + limit).map((data, index) => (
                                    <TableRow key={index}>
                                      <TableCell align={'left'} component="th" scope="row" style={{ border: "1px solid #ccc" }}>
                                        {data.registrationNumber}
                                      </TableCell>
                                      <TableCell align={'left'} component="th" scope="row" style={{ border: "1px solid #ccc" }}>
                                        {data.name}
                                      </TableCell>
                                      <TableCell align={'left'} component="th" scope="row" style={{ border: "1px solid #ccc" }}>
                                        {data.routeName}
                                      </TableCell>
                                      <TableCell align={'left'} component="th" scope="row" style={{ border: "1px solid #ccc" }}>
                                        {data.bankName}
                                      </TableCell>
                                      <TableCell align={'left'} component="th" scope="row" style={{ border: "1px solid #ccc" }}>
                                        {data.branchName}
                                      </TableCell>
                                      <TableCell align={'left'} component="th" scope="row" style={{ border: "1px solid #ccc" }}>
                                        {data.accountNumber}
                                      </TableCell>
                                      <TableCell align={'left'} component="th" scope="row" style={{ border: "1px solid #ccc" }}>
                                        052 - Suppliers
                                      </TableCell>
                                      <TableCell align={'right'} component="th" scope="row" style={{ border: "1px solid #ccc" }}>
                                        {data.amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                      </TableCell>
                                    </TableRow>
                                  ))}
                                </TableBody>
                              </Table>
                              <TablePagination
                                component="div"
                                count={bankCustomerData.length}
                                onChangePage={handlePageChange}
                                onChangeRowsPerPage={handleLimitChange}
                                page={page}
                                rowsPerPage={limit}
                                rowsPerPageOptions={[5, 10, 25]}
                              />
                            </TableContainer>
                          ) : null}
                        </Box>
                      </CardContent>
                      {bankCustomerData.length > 0 ? (
                        <Box display="flex" justifyContent="flex-end" p={2}>
                          <Button
                            color="primary"
                            id="btnRecord"
                            type="submit"
                            variant="contained"
                            style={{ marginRight: '1rem' }}
                            className={classes.colorRecord}
                            onClick={createFile}
                            size="small"
                          >
                            EXCEL
                          </Button>
                          <div>&nbsp;</div>
                          <ReactToPrint
                            documentTitle={'Pay Past Report - RTF'}
                            trigger={() => (
                              <Button
                                color="primary"
                                id="btnCancel"
                                variant="contained"
                                style={{ marginRight: '1rem' }}
                                className={classes.colorCancel}
                                size="small"
                              >
                                PDF
                              </Button>
                            )}
                            pageStyle={getPageMargins()}
                            content={() => componentRef.current}
                          />
                          <div hidden={true}>
                            <CreatePDF
                              ref={componentRef}
                              BankCustomerList={bankCustomerList}
                              TotalAmount={totalAmount}
                              totalAmountpdf={totalAmountpdf}
                              BankCustomerSearchData={selectedSearchValues}
                              BankCustomerData={bankCustomerData}
                              selectedDatePDF={selectedDatePDF}
                              bankName={bankName}
                              branchName={branchName}
                            />

                            <CreateBankWiseCustomerPDF
                              ref={componentRef1}
                              BankCustomerList={bankCustomerList}
                              TotalAmount={totalAmount}
                              totalAmountpdf={totalAmountpdf}
                              BankCustomerSearchData={selectedSearchValues}
                              BankCustomerData={bankCustomerData}
                              selectedDatePDF={selectedDatePDF}
                            />
                          </div>
                        </Box>
                      ) : null}
                    </PerfectScrollbar>
                  </Card>
                </Box>
              </form>
            )}
          </Formik>
        </Container>
      </Page>
    </Fragment>
  );
}
